export default __webpack_public_path__ + "static/media/icn_ybx1.ca6acbfe.svg";